module.exports = __webpack_public_path__ + "static/media/AngelsOfAether_Race_04.12770ff6.jpg";